import { HttpAuthRepository } from './infrastructure/repositories/HttpAuthRepository';
import { LoginUseCase } from './application/use-cases/LoginUseCase';
import { RegisterUseCase } from './application/use-cases/RegisterUseCase';
import { LogoutUseCase } from './application/use-cases/LogoutUseCase';
import { ForgotPasswordUseCase } from './application/use-cases/ForgotPasswordUseCase';
import { ResetPasswordUseCase } from './application/use-cases/ResetPasswordUseCase';

type AuthUseCases = {
  login: LoginUseCase;
  register: RegisterUseCase;
  logout: LogoutUseCase;
  forgotPassword: ForgotPasswordUseCase;
  resetPassword: ResetPasswordUseCase;
};

let cachedUseCases: AuthUseCases | null = null;

function getAuthUseCases(): AuthUseCases {
  if (cachedUseCases) {
    return cachedUseCases;
  }

  const authRepository = new HttpAuthRepository();

  cachedUseCases = {
    login: new LoginUseCase(authRepository),
    register: new RegisterUseCase(authRepository),
    logout: new LogoutUseCase(authRepository),
    forgotPassword: new ForgotPasswordUseCase(authRepository),
    resetPassword: new ResetPasswordUseCase(authRepository),
  };

  return cachedUseCases;
}

export const authUseCases = {
  get login() {
    return getAuthUseCases().login;
  },
  get register() {
    return getAuthUseCases().register;
  },
  get logout() {
    return getAuthUseCases().logout;
  },
  get forgotPassword() {
    return getAuthUseCases().forgotPassword;
  },
  get resetPassword() {
    return getAuthUseCases().resetPassword;
  },
};
